/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimCheckResponseDto,
  ClaimDuplicationCheckPayloadDto,
  ClaimPaginationResponseDto,
  ClaimResponseDto,
  CreateClaimPayloadDto,
  ErrorResponse,
  FilterClaimsQueryDto,
  UpdateClaimPayloadDto,
} from '../models/index';
import {
    ClaimCheckResponseDtoFromJSON,
    ClaimCheckResponseDtoToJSON,
    ClaimDuplicationCheckPayloadDtoFromJSON,
    ClaimDuplicationCheckPayloadDtoToJSON,
    ClaimPaginationResponseDtoFromJSON,
    ClaimPaginationResponseDtoToJSON,
    ClaimResponseDtoFromJSON,
    ClaimResponseDtoToJSON,
    CreateClaimPayloadDtoFromJSON,
    CreateClaimPayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FilterClaimsQueryDtoFromJSON,
    FilterClaimsQueryDtoToJSON,
    UpdateClaimPayloadDtoFromJSON,
    UpdateClaimPayloadDtoToJSON,
} from '../models/index';

export interface CheckDuplicatedClaimRequest {
    claimDuplicationCheckPayloadDto: ClaimDuplicationCheckPayloadDto;
}

export interface CreateClaimRequest {
    createClaimPayloadDto: CreateClaimPayloadDto;
}

export interface FilterClaimsRequest {
    filterClaimsQueryDto: FilterClaimsQueryDto;
    field?: FilterClaimsFieldEnum;
    order?: FilterClaimsOrderEnum;
    page?: number;
    pageSize?: number;
}

export interface GetClaimByIdRequest {
    claimId: string;
    includeInsured?: boolean;
    includeClaimHandler?: boolean;
    includeBinderClaims?: boolean;
}

export interface UpdateClaimRequest {
    claimId: string;
    updateClaimPayloadDto: UpdateClaimPayloadDto;
}

/**
 * 
 */
export class ClaimsApi extends runtime.BaseAPI {

    /**
     * Check duplicated claim
     */
    async checkDuplicatedClaimRaw(requestParameters: CheckDuplicatedClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCheckResponseDto>> {
        if (requestParameters['claimDuplicationCheckPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'claimDuplicationCheckPayloadDto',
                'Required parameter "claimDuplicationCheckPayloadDto" was null or undefined when calling checkDuplicatedClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/claims/duplicated-check`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimDuplicationCheckPayloadDtoToJSON(requestParameters['claimDuplicationCheckPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimCheckResponseDtoFromJSON(jsonValue));
    }

    /**
     * Check duplicated claim
     */
    async checkDuplicatedClaim(requestParameters: CheckDuplicatedClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCheckResponseDto> {
        const response = await this.checkDuplicatedClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create claim
     */
    async createClaimRaw(requestParameters: CreateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimResponseDto>> {
        if (requestParameters['createClaimPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createClaimPayloadDto',
                'Required parameter "createClaimPayloadDto" was null or undefined when calling createClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/claims`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimPayloadDtoToJSON(requestParameters['createClaimPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create claim
     */
    async createClaim(requestParameters: CreateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimResponseDto> {
        const response = await this.createClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Filter claims
     */
    async filterClaimsRaw(requestParameters: FilterClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPaginationResponseDto>> {
        if (requestParameters['filterClaimsQueryDto'] == null) {
            throw new runtime.RequiredError(
                'filterClaimsQueryDto',
                'Required parameter "filterClaimsQueryDto" was null or undefined when calling filterClaims().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/claims/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterClaimsQueryDtoToJSON(requestParameters['filterClaimsQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter claims
     */
    async filterClaims(requestParameters: FilterClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPaginationResponseDto> {
        const response = await this.filterClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get claim by id
     */
    async getClaimByIdRaw(requestParameters: GetClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeInsured'] != null) {
            queryParameters['includeInsured'] = requestParameters['includeInsured'];
        }

        if (requestParameters['includeClaimHandler'] != null) {
            queryParameters['includeClaimHandler'] = requestParameters['includeClaimHandler'];
        }

        if (requestParameters['includeBinderClaims'] != null) {
            queryParameters['includeBinderClaims'] = requestParameters['includeBinderClaims'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/claims/{claimId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get claim by id
     */
    async getClaimById(requestParameters: GetClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimResponseDto> {
        const response = await this.getClaimByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update claim
     */
    async updateClaimRaw(requestParameters: UpdateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling updateClaim().'
            );
        }

        if (requestParameters['updateClaimPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateClaimPayloadDto',
                'Required parameter "updateClaimPayloadDto" was null or undefined when calling updateClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/claims/{claimId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClaimPayloadDtoToJSON(requestParameters['updateClaimPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update claim
     */
    async updateClaim(requestParameters: UpdateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimResponseDto> {
        const response = await this.updateClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const FilterClaimsFieldEnum = {
    Insured: 'insured',
    Status: 'status',
    LineOfBusiness: 'lineOfBusiness',
    DateReported: 'dateReported',
    ClaimsHandler: 'claimsHandler'
} as const;
export type FilterClaimsFieldEnum = typeof FilterClaimsFieldEnum[keyof typeof FilterClaimsFieldEnum];
/**
 * @export
 */
export const FilterClaimsOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type FilterClaimsOrderEnum = typeof FilterClaimsOrderEnum[keyof typeof FilterClaimsOrderEnum];
